import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c70e1f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "agreement-container xa-line__full-top" }
const _hoisted_2 = { class: "pb32" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title mb16 ftw" }, "退保规则", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " 兹经保险合同双方同意，保险人同意在投保人投保后，投保人在保单生效前要求解除保险合同，保险人可全额退还投保人保费；投保人在保单生效后未产生理赔（待理赔的保单在放弃索赔后）要求解除保险合同，保险人按短期费率计收保险责任开始之日起至合同解除之日止期间的保险费，并退还剩余部分保险费。如果被保险无人机在本保险合同下已经发生了损失索赔或已经支付过赔款，则对于该架被保险无人机将不再退还保费。 ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title mb16 ftw mt16",
  style: {"text-align":"center"}
}, "短期费率表", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "table-item",
  cellpadding: "0",
  cellspacing: "0"
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "保险期间已经过月数（个月）"),
    /*#__PURE__*/_createElementVNode("th", null, "年费率的比例（％）")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "1"),
    /*#__PURE__*/_createElementVNode("td", null, "20")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "2"),
    /*#__PURE__*/_createElementVNode("td", null, "30")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "3"),
    /*#__PURE__*/_createElementVNode("td", null, "60")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "4"),
    /*#__PURE__*/_createElementVNode("td", null, "65")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "5"),
    /*#__PURE__*/_createElementVNode("td", null, "70")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "6"),
    /*#__PURE__*/_createElementVNode("td", null, "75")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "7"),
    /*#__PURE__*/_createElementVNode("td", null, "80")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "8"),
    /*#__PURE__*/_createElementVNode("td", null, "85")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "9"),
    /*#__PURE__*/_createElementVNode("td", null, "90")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "10"),
    /*#__PURE__*/_createElementVNode("td", null, "95")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "11"),
    /*#__PURE__*/_createElementVNode("td", null, "98")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", null, "12"),
    /*#__PURE__*/_createElementVNode("td", null, "100")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content mt16 tips" }, "注：保险期间已经过月数不足一月的按一月计算", -1))
const _hoisted_8 = {
  key: 1,
  class: "content"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#cc0000"} }, "按日比例将相应保费", -1))
const _hoisted_10 = { class: "footer xag-page__footer nongfu-button-wrap" }

import { useRouter, useRoute } from 'vue-router'
import { Button } from 'vant'
import AppHeader from '@/components/Header.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'insurance-refund-word',
  setup(__props) {

const $router = useRouter()
const $route = useRoute()
const type = $route.query.type as string

function back() {
  $router.go(-1)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "退保规则" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_unref(type) === '2024')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7
            ], 64))
          : _createCommentVNode("", true),
        (_unref(type) === '2023')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createTextVNode(" 经保险合同双方同意，保险人同意在投保人投保后，投保人在保单生效前要求解除保险合同，保险人可全额退还投保人保费；投保人在保单生效后未产生理赔（待理赔的保单在放弃索赔后）要求解除保险合同，保险人就保险合同未尽期间"),
              _hoisted_9,
              _createTextVNode("退还投保人。如果被保险无人机在本保险合同下已经发生了损失索赔或已经支付过赔款，则对于该架被保险无人机将不再退还保费。 ")
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_unref(Button), {
        block: "",
        type: "success",
        class: "xa-vant-button",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})